import { BaseEncoder } from './BaseEncoder';
import { BaseObjectEncoder } from './BaseObjectEncoder';
import { DefaultBaseObjectEncoderImpl } from './DefaultBaseObjectEncoderImpl';

import { FwdRollOrderAllocationPricingImpl } from '../model/impl/FwdRollOrderAllocationPricingImpl';
import { Encodable } from '../model/Encodable';

import * as CubiqTS from "../index";

export class FwdRollOrderAllocationPricingImplEncoder implements BaseEncoder {
    public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

    private static _instance;

    private constructor () {

    }

    public static get Instance()
    {
        // Do you need arguments? Make it a regular method instead.
        return this._instance || (this._instance = new this());
    }

    public encode(encodable: FwdRollOrderAllocationPricingImpl, streamout: CubiqTS.ByteBuffer): void {
        this.baseEncoder.encode(encodable, streamout);

        this.baseEncoder.writeStartEncoding(streamout);

        /*Object encoding*/
        if(encodable.baseCcy!=null){
            this.baseEncoder.writeStartFid(1,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(1),false,encodable.baseCcy,streamout);
            this.baseEncoder.writeEndFid(1,streamout);
        }
        /*Object encoding*/
        if(encodable.nonBaseCcy!=null){
            this.baseEncoder.writeStartFid(2,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(2),false,encodable.nonBaseCcy,streamout);
            this.baseEncoder.writeEndFid(2,streamout);
        }
        /*Object encoding*/
        if(encodable.fixedCcy!=null){
            this.baseEncoder.writeStartFid(3,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(3),false,encodable.fixedCcy,streamout);
            this.baseEncoder.writeEndFid(3,streamout);
        }
        /*Object encoding*/
        if(encodable.clientIntent!=null){
            this.baseEncoder.writeStartFid(4,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(4),false,encodable.clientIntent,streamout);
            this.baseEncoder.writeEndFid(4,streamout);
        }
        /*Object encoding*/
        if(encodable.product!=null){
            this.baseEncoder.writeStartFid(5,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(5),false,encodable.product,streamout);
            this.baseEncoder.writeEndFid(5,streamout);
        }
        /*Object encoding*/
        if(encodable.settleTenor!=null){
            this.baseEncoder.writeStartFid(6,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(6),false,encodable.settleTenor,streamout);
            this.baseEncoder.writeEndFid(6,streamout);
        }
        /*Object encoding*/
        if(encodable.settleDate!=null){
            this.baseEncoder.writeStartFid(7,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(7),false,encodable.settleDate,streamout);
            this.baseEncoder.writeEndFid(7,streamout);
        }
        /*Object encoding*/
        if(encodable.fixedAmt!=null){
            this.baseEncoder.writeStartFid(8,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(8),false,encodable.fixedAmt,streamout);
            this.baseEncoder.writeEndFid(8,streamout);
        }
        /*Object encoding*/
        if(encodable.counterAmt!=null){
            this.baseEncoder.writeStartFid(9,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(9),false,encodable.counterAmt,streamout);
            this.baseEncoder.writeEndFid(9,streamout);
        }
        /*Object encoding*/
        if(encodable.marketSpotRate!=null){
            this.baseEncoder.writeStartFid(10,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10),false,encodable.marketSpotRate,streamout);
            this.baseEncoder.writeEndFid(10,streamout);
        }
        /*Object encoding*/
        if(encodable.marketForwardPts!=null){
            this.baseEncoder.writeStartFid(11,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(11),false,encodable.marketForwardPts,streamout);
            this.baseEncoder.writeEndFid(11,streamout);
        }
        /*Object encoding*/
        if(encodable.marketForwardRate!=null){
            this.baseEncoder.writeStartFid(12,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(12),false,encodable.marketForwardRate,streamout);
            this.baseEncoder.writeEndFid(12,streamout);
        }
        /*Object encoding*/
        if(encodable.spotMarkup!=null){
            this.baseEncoder.writeStartFid(13,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(13),false,encodable.spotMarkup,streamout);
            this.baseEncoder.writeEndFid(13,streamout);
        }
        /*Object encoding*/
        if(encodable.clientSpotRate!=null){
            this.baseEncoder.writeStartFid(14,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(14),false,encodable.clientSpotRate,streamout);
            this.baseEncoder.writeEndFid(14,streamout);
        }
        /*Object encoding*/
        if(encodable.clientForwardPts!=null){
            this.baseEncoder.writeStartFid(15,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(15),false,encodable.clientForwardPts,streamout);
            this.baseEncoder.writeEndFid(15,streamout);
        }
        /*Object encoding*/
        if(encodable.clientForwardRate!=null){
            this.baseEncoder.writeStartFid(16,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(16),false,encodable.clientForwardRate,streamout);
            this.baseEncoder.writeEndFid(16,streamout);
        }
        /*Object encoding*/
        if(encodable.fwdMarkup!=null){
            this.baseEncoder.writeStartFid(17,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(17),false,encodable.fwdMarkup,streamout);
            this.baseEncoder.writeEndFid(17,streamout);
        }
        /*Object encoding*/
        if(encodable.accountName!=null){
            this.baseEncoder.writeStartFid(18,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(18),false,encodable.accountName,streamout);
            this.baseEncoder.writeEndFid(18,streamout);
        }
        /*Object encoding*/
        if(encodable.allocationId!=null){
            this.baseEncoder.writeStartFid(19,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(19),false,encodable.allocationId,streamout);
            this.baseEncoder.writeEndFid(19,streamout);
        }
        /*Object encoding*/
        if(encodable.channelCd!=null){
            this.baseEncoder.writeStartFid(20,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(20),false,encodable.channelCd,streamout);
            this.baseEncoder.writeEndFid(20,streamout);
        }
        /*Object encoding*/
        if(encodable.clientCode!=null){
            this.baseEncoder.writeStartFid(21,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(21),false,encodable.clientCode,streamout);
            this.baseEncoder.writeEndFid(21,streamout);
        }
        /*Object encoding*/
        if(encodable.clientName!=null){
            this.baseEncoder.writeStartFid(22,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(22),false,encodable.clientName,streamout);
            this.baseEncoder.writeEndFid(22,streamout);
        }
        /*Object encoding*/
        if(encodable.entryDts!=null){
            this.baseEncoder.writeStartFid(23,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(23),false,encodable.entryDts,streamout);
            this.baseEncoder.writeEndFid(23,streamout);
        }
        /*Object encoding*/
        if(encodable.entryUserCode!=null){
            this.baseEncoder.writeStartFid(24,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(24),false,encodable.entryUserCode,streamout);
            this.baseEncoder.writeEndFid(24,streamout);
        }
        /*Object encoding*/
        if(encodable.oboAccount!=null){
            this.baseEncoder.writeStartFid(25,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(25),false,encodable.oboAccount,streamout);
            this.baseEncoder.writeEndFid(25,streamout);
        }
        /*Object encoding*/
        if(encodable.oboClient!=null){
            this.baseEncoder.writeStartFid(26,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(26),false,encodable.oboClient,streamout);
            this.baseEncoder.writeEndFid(26,streamout);
        }
        /*Object encoding*/
        if(encodable.oboEntryUser!=null){
            this.baseEncoder.writeStartFid(27,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(27),false,encodable.oboEntryUser,streamout);
            this.baseEncoder.writeEndFid(27,streamout);
        }
        /*Object encoding*/
        if(encodable.usdEquivAmt!=null){
            this.baseEncoder.writeStartFid(28,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(28),false,encodable.usdEquivAmt,streamout);
            this.baseEncoder.writeEndFid(28,streamout);
        }
        /*Object encoding*/
        if(encodable.orderId!=null){
            this.baseEncoder.writeStartFid(29,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(29),false,encodable.orderId,streamout);
            this.baseEncoder.writeEndFid(29,streamout);
        }
        /*Object encoding*/
        if(encodable.orderRef!=null){
            this.baseEncoder.writeStartFid(30,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(30),false,encodable.orderRef,streamout);
            this.baseEncoder.writeEndFid(30,streamout);
        }
        /*Object encoding*/
        if(encodable.privateComments!=null){
            this.baseEncoder.writeStartFid(31,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(31),false,encodable.privateComments,streamout);
            this.baseEncoder.writeEndFid(31,streamout);
        }
        /*Object encoding*/
        if(encodable.clientComments!=null){
            this.baseEncoder.writeStartFid(32,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(32),false,encodable.clientComments,streamout);
            this.baseEncoder.writeEndFid(32,streamout);
        }
        /*Object encoding*/
        if(encodable.salesGroupId!=null){
            this.baseEncoder.writeStartFid(33,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(33),false,encodable.salesGroupId,streamout);
            this.baseEncoder.writeEndFid(33,streamout);
        }
        /*Object encoding*/
        if(encodable.userUpdatedFg!=null){
            this.baseEncoder.writeStartFid(34,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(34),false,encodable.userUpdatedFg,streamout);
            this.baseEncoder.writeEndFid(34,streamout);
        }
        /*Object encoding*/
        if(encodable.forwardFirstOrder!=null){
            this.baseEncoder.writeStartFid(35,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(35),false,encodable.forwardFirstOrder,streamout);
            this.baseEncoder.writeEndFid(35,streamout);
        }
        /*Object encoding*/
        if(encodable.reqForwardPts!=null){
            this.baseEncoder.writeStartFid(36,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(36),false,encodable.reqForwardPts,streamout);
            this.baseEncoder.writeEndFid(36,streamout);
        }
        /*Object encoding*/
        if(encodable.failedAdjCalculation!=null){
            this.baseEncoder.writeStartFid(37,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(37),false,encodable.failedAdjCalculation,streamout);
            this.baseEncoder.writeEndFid(37,streamout);
        }
        /*Object encoding*/
        if(encodable.messageId!=null){
            this.baseEncoder.writeStartFid(100,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(100),false,encodable.messageId,streamout);
            this.baseEncoder.writeEndFid(100,streamout);
        }
        /*Object encoding*/
        if(encodable.brokerId!=null){
            this.baseEncoder.writeStartFid(200,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(200),false,encodable.brokerId,streamout);
            this.baseEncoder.writeEndFid(200,streamout);
        }
        /*Object encoding*/
        if(encodable.secureToken!=null){
            this.baseEncoder.writeStartFid(300,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(300),true,encodable.secureToken,streamout);
            this.baseEncoder.writeEndFid(300,streamout);
        }
        /*Object encoding*/
        if(encodable.rowId!=null){
            this.baseEncoder.writeStartFid(590,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(590),false,encodable.rowId,streamout);
            this.baseEncoder.writeEndFid(590,streamout);
        }
        /*Object encoding*/
        if(encodable.proxySessionId!=null){
            this.baseEncoder.writeStartFid(999,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(999),false,encodable.proxySessionId,streamout);
            this.baseEncoder.writeEndFid(999,streamout);
        }
        /*Object encoding*/
        if(encodable.svrRxTime!=null){
            this.baseEncoder.writeStartFid(10000,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10000),false,encodable.svrRxTime,streamout);
            this.baseEncoder.writeEndFid(10000,streamout);
        }
        /*Object encoding*/
        if(encodable.svrTxTime!=null){
            this.baseEncoder.writeStartFid(10001,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10001),false,encodable.svrTxTime,streamout);
            this.baseEncoder.writeEndFid(10001,streamout);
        }
        /*Object encoding*/
        if(encodable.cliTxTime!=null){
            this.baseEncoder.writeStartFid(10002,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10002),false,encodable.cliTxTime,streamout);
            this.baseEncoder.writeEndFid(10002,streamout);
        }
        /*Object encoding*/
        if(encodable.cliRxTime!=null){
            this.baseEncoder.writeStartFid(10003,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10003),false,encodable.cliRxTime,streamout);
            this.baseEncoder.writeEndFid(10003,streamout);
        }
        /*Object encoding*/
        if(encodable.sessionOnly!=null){
            this.baseEncoder.writeStartFid(10010,streamout);
            this.baseEncoder.writeObject(false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
            this.baseEncoder.writeEndFid(10010,streamout);
        }
        this.baseEncoder.writeEndEncoding(streamout);

    }

    static fidTypeMap: Map<number, string> = new Map<number, string>([
            [1, "java.lang.String"],
            [2, "java.lang.String"],
            [3, "java.lang.String"],
            [4, "com.bcdfx.model.OrderIntent"],
            [5, "com.bcdfx.model.Product"],
            [6, "com.bcdfx.model.Tenor"],
            [7, "java.util.Date"],
            [8, "java.math.BigDecimal"],
            [9, "java.math.BigDecimal"],
            [10, "java.math.BigDecimal"],
            [11, "java.math.BigDecimal"],
            [12, "java.math.BigDecimal"],
            [13, "java.math.BigDecimal"],
            [14, "java.math.BigDecimal"],
            [15, "java.math.BigDecimal"],
            [16, "java.math.BigDecimal"],
            [17, "java.math.BigDecimal"],
            [18, "java.lang.String"],
            [19, "java.lang.Long"],
            [20, "java.lang.String"],
            [21, "java.lang.String"],
            [22, "java.lang.String"],
            [23, "java.util.Date"],
            [24, "java.lang.String"],
            [25, "java.lang.String"],
            [26, "java.lang.String"],
            [27, "java.lang.String"],
            [28, "java.math.BigDecimal"],
            [29, "java.lang.Long"],
            [30, "java.lang.String"],
            [31, "java.lang.String"],
            [32, "java.lang.String"],
            [33, "java.lang.Long"],
            [34, "java.lang.Boolean"],
            [35, "java.lang.Boolean"],
            [36, "java.math.BigDecimal"],
            [37, "java.lang.Boolean"],
            [100, "java.lang.String"],
            [200, "java.lang.String"],
            [300, "com.bcdfx.security.SecureToken"],
            [590, "java.lang.String"],
            [999, "java.lang.String"],
            [10000, "java.lang.Long"],
            [10001, "java.lang.Long"],
            [10002, "java.lang.Long"],
            [10003, "java.lang.Long"],
            [10010, "java.lang.String"],
    ]);

    /**
     * Constructs the event from a given byte stream
     */
    public decode(encodable: FwdRollOrderAllocationPricingImpl, streamin:CubiqTS.ByteBuffer): void
    {
        this.baseEncoder.decode(encodable, streamin);

        while(true)
        {
            let ct:string=this.baseEncoder.readCtrl(streamin);
            if(ct=="^F")
            {
                break;
            }
            if(ct=="^H")
                continue;
            let fid:number=this.baseEncoder.parseCtrlAsFid(ct);
            if(this.supportsFid(fid)==false)
                this.baseEncoder.seekToNextFid(fid,streamin);
            switch(fid)
            {

                case 1:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(1),streamin);
                    encodable.baseCcy=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 2:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(2),streamin);
                    encodable.nonBaseCcy=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 3:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(3),streamin);
                    encodable.fixedCcy=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 4:
                {
                    /*Object encoding*/
                    let val:CubiqTS.OrderIntent=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(4),streamin);
                    encodable.clientIntent=<CubiqTS.OrderIntent>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 5:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Product=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(5),streamin);
                    encodable.product=<CubiqTS.Product>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 6:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Tenor=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(6),streamin);
                    encodable.settleTenor=<CubiqTS.Tenor>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 7:
                {
                    /*Object encoding*/
                    let val:CubiqTS.moment.Moment=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(7),streamin);
                    encodable.settleDate=<CubiqTS.moment.Moment>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 8:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(8),streamin);
                    encodable.fixedAmt=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 9:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(9),streamin);
                    encodable.counterAmt=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 10:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10),streamin);
                    encodable.marketSpotRate=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 11:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(11),streamin);
                    encodable.marketForwardPts=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 12:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(12),streamin);
                    encodable.marketForwardRate=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 13:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(13),streamin);
                    encodable.spotMarkup=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 14:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(14),streamin);
                    encodable.clientSpotRate=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 15:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(15),streamin);
                    encodable.clientForwardPts=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 16:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(16),streamin);
                    encodable.clientForwardRate=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 17:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(17),streamin);
                    encodable.fwdMarkup=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 18:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(18),streamin);
                    encodable.accountName=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 19:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(19),streamin);
                    encodable.allocationId=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 20:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(20),streamin);
                    encodable.channelCd=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 21:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(21),streamin);
                    encodable.clientCode=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 22:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(22),streamin);
                    encodable.clientName=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 23:
                {
                    /*Object encoding*/
                    let val:CubiqTS.moment.Moment=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(23),streamin);
                    encodable.entryDts=<CubiqTS.moment.Moment>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 24:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(24),streamin);
                    encodable.entryUserCode=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 25:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(25),streamin);
                    encodable.oboAccount=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 26:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(26),streamin);
                    encodable.oboClient=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 27:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(27),streamin);
                    encodable.oboEntryUser=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 28:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(28),streamin);
                    encodable.usdEquivAmt=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 29:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(29),streamin);
                    encodable.orderId=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 30:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(30),streamin);
                    encodable.orderRef=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 31:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(31),streamin);
                    encodable.privateComments=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 32:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(32),streamin);
                    encodable.clientComments=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 33:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(33),streamin);
                    encodable.salesGroupId=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 34:
                {
                    /*Object encoding*/
                    let val:boolean=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(34),streamin);
                    encodable.userUpdatedFg=<boolean>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 35:
                {
                    /*Object encoding*/
                    let val:boolean=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(35),streamin);
                    encodable.forwardFirstOrder=<boolean>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 36:
                {
                    /*Object encoding*/
                    let val:CubiqTS.BigNumber=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(36),streamin);
                    encodable.reqForwardPts=<CubiqTS.BigNumber>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 37:
                {
                    /*Object encoding*/
                    let val:boolean=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(37),streamin);
                    encodable.failedAdjCalculation=<boolean>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 100:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(100),streamin);
                    encodable.messageId=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 200:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(200),streamin);
                    encodable.brokerId=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 300:
                {
                    /*Object encoding*/
                    let val:CubiqTS.SecureToken=this.baseEncoder.readObject(true,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(300),streamin);
                    encodable.secureToken=<CubiqTS.SecureToken>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 590:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(590),streamin);
                    encodable.rowId=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 999:
                {
                    /*Object encoding*/
                    let val:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(999),streamin);
                    encodable.proxySessionId=<string>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 10000:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10000),streamin);
                    encodable.svrRxTime=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 10001:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10001),streamin);
                    encodable.svrTxTime=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 10002:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10002),streamin);
                    encodable.cliTxTime=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 10003:
                {
                    /*Object encoding*/
                    let val:CubiqTS.Long=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10003),streamin);
                    encodable.cliRxTime=<CubiqTS.Long>val;
                    this.baseEncoder.readEndFid(streamin);
                    break;
                }
                case 10010:
                {
                    /*Object encoding*/
                    let val_10010:string=this.baseEncoder.readObject(false,false,FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.get(10010),streamin);
                    encodable.sessionOnly=val_10010;
                    this.baseEncoder.readEndFid(streamin);
            break;
                }
            }
        }
    }

    private supportsFid(fid:number):boolean {
        return FwdRollOrderAllocationPricingImplEncoder.fidTypeMap.has(fid);
    }
}
